/**
 * Created by Carsten Bühler
 * User: c.buehler on 02.03.2021
 * Copyright: xdot GmbH 2021
 */

'use strict';


//Includes
import React from 'external/react';
import PropTypes from 'external/prop-types';
import {
    AppContext,
    DataUtil,
    RoleUtil,
    ContextContainer
} from 'plugin/liferay-widgets-react-web';

import  Icon  from '../components/Icon';
import {  getFliwasPermissionStore } from '../stores/StoreFactory';
import FliwasPermissionActions from '../actions/FliwasPermissionActions';
import { Button } from 'external/react-bootstrap';

//Stores
const FliwasPermissionStore = getFliwasPermissionStore(AppContext);

class JournalAddEntryButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogRemoveDocumentAssetLinkOpened: false,
            searchValue: ''
        };

        this.DATA = {
            JOURNAL_CREATE_PERMISSION: this.withCtx('JournalCreatePermission'),
            USER_ROLES: this.withCtx('UserRoles')
        };
    }

    static getStores() {
        return [
            FliwasPermissionStore
        ];
    }

    static calculateState(prevState, undefined, DATA) {
        return {
            userRolesDataItem: FliwasPermissionStore.getRemoteData(DATA.USER_ROLES),
            documentPermissionDataItem: FliwasPermissionStore.getRemoteData(DATA.JOURNAL_CREATE_PERMISSION)
        };
    }

    componentDidMount() {
        FliwasPermissionActions.getPermissionState(this.DATA.JOURNAL_CREATE_PERMISSION, {
            nameSpace: 'journal',
            fliwasPermission: 'create'
        });

        FliwasPermissionActions.getUserRoles(this.DATA.USER_ROLES, {
            userId: AppContext.getUserId()
        });
    }


    render() {
        const { userRolesDataItem, documentPermissionDataItem } = this.state;
        const  userRoles = DataUtil.asObject(userRolesDataItem),
            documentPermission = DataUtil.asItem(documentPermissionDataItem),
            isAdmin = RoleUtil.isOrganizationAdmin(userRoles)

        const hasPermission = ((documentPermission && documentPermission.state && documentPermission.state.toLowerCase() === 'set') || isAdmin);
        if (hasPermission) {
            return (
                <Button
                    className="mini-widget__journal_entry_button"
                    variant="outline-primary"
                    title="Journaleintrag erstellen"
                    onClick={this.props.onClick}
                    size="lg"
                >
                    <Icon name="journal_add"/>
                </Button>
            );
        }

        return null;
    }
}

JournalAddEntryButton.propTypes = {
    onClick: PropTypes.func
};

export default ContextContainer.create(JournalAddEntryButton);



// WEBPACK FOOTER //
// ./js/components/JournalAddEntryButton.jsx